export default {
	lia: {
		viewingAsAccount:
			'Ihre Daten werden gerade aus der Sicht des Kontos von\n <b class="text-white"> {name}</b> angezeigt',
	},
}
